import { FC, SVGProps } from "react";

const TransactionsIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <svg viewBox="0 0 24 24"  strokeLinecap="round" strokeLinejoin="round" fill="none" stroke="currentcolor" strokeWidth={1.5} className="w-full h-full" {...props}>
    <path  d="M9 12h6m-3-3v6M4 6h16M4 10h4M4 14h4M4 18h16" />
  </svg>
};

export default TransactionsIcon;;

